import React, { useEffect, useRef, useState } from "react";
import { Box, MenuItem, TextField, IconButton, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CommonColorUtils from "../../utils/common_colors";
import StringUtils from "../../utils/string_utils";

const SearchFilterComboBox = ({
  filterOptions = [],
  selectedFilter,
  onFilterChange,
  onPressEnter,
  searchText,
  onSearchTextChange,
  width = 250,
  placeholder = StringUtils.searchLabel,
  disabled
}) => {
  const [localText, setLocalText] = useState(searchText);
  const debounceRef = useRef(null);

  useEffect(() => {
    setLocalText(searchText);
  }, [searchText]);

  useEffect(() => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      onSearchTextChange({ target: { value: localText } });
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [localText]);

  const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    onPressEnter?.(localText);
  }
};

  return (
    <Box
      sx={{
        minWidth: width,
        display: "flex",
        alignItems: "center",
        border: `1px solid ${CommonColorUtils.kBorderColorComboSearchBox}`,
        borderRadius: "10px",
        paddingLeft: 1,
        mr: 1,
        mt: 1.5,
        height: 48,
        background: "#fff",
        fontSize: 14,
      }}
    >
      <TextField
        select
        value={selectedFilter}
        onChange={onFilterChange}
        disabled={disabled} 
        variant="standard"
        sx={{
          minWidth: 80,
          "& .MuiInputBase-input": {
          fontSize: 14,
          fontWeight: 600,
      },
          borderRight: `1px solid ${CommonColorUtils.kBorderColorComboSearchBox}`,
          "& .MuiInputBase-root": { borderBottom: "none !important" },
        }}
        InputProps={{ disableUnderline: true }}
        SelectProps={{
          disabled: disabled,
          MenuProps: {
            PaperProps: {
              sx: {
                p: "0 6px",
                "& .MuiMenuItem-root": {
                  fontSize: 14,  
                  borderRadius: "4px", 
                },
                "& .Mui-selected": {
                 fontWeight: 600,
                 backgroundColor: "#EBECEF !important", // ⬅️ selected background
                },
              },
            },
          },
        }}
      >
        {filterOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>

      <InputBase
        placeholder={placeholder}
        value={localText}
        disabled={disabled} 
        onChange={(e) => setLocalText(e.target.value)}
        onKeyDown={handleKeyDown}
        sx={{
          ml: 0.5,
          flex: 1,
          fontSize: 12,
        }}
      />

      <IconButton sx={{ p: 0.5 }} onClick={() => onPressEnter?.(localText)}>
        <SearchIcon />
      </IconButton>
    </Box>
  );
};

export default SearchFilterComboBox;
